import React, {useState, useEffect } from "react"
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import SaveIcon from '@material-ui/icons/Save'
import LabelIcon from '@material-ui/icons/Label';
import CloudDownload from '@material-ui/icons/CloudDownload'
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import {useFinalSOPs, setFinalSOPs, usePlan, setPlan, setUpdatePlan, setSelectedSOPs, setOpenPlan, setDocs, setStepsCompleted, useSelectedSOPs} from '../../redux/plan'
import TextField from '@material-ui/core/TextField'
import { useName, useToken } from '../../redux/auth'
import axios from 'axios'
import {convertPlanToDocx, getSOPByID, savePlan , api, uploadPlanToGDocs, getCompanyDetails } from '../../modules/db'
import DeleteIcon from '@material-ui/icons/Delete'
import ThumbUpIcon from '@material-ui/icons/ThumbUp'
import { setSelectedModule, setOpenDialog, setRedirectToPreview } from '../../redux/navigation'
import Dialog from '../closedialog'
import Auto from "../autocomplete"
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns'
import NewTagDialog from '../newtagdialog'
import _ from 'lodash'
import moment from 'moment'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { editorType } from "../creator"
import { toPng } from 'html-to-image'
import SopView from "./SopViewer"
import GroupedSopViewe from "./GroupedSopViewer"
import { theme } from "../../theme";
import { handleCreateWord } from "../../utils/docxGenerator";
import { saveAs } from "file-saver";
import { Packer } from "docx";

//const useStyles = makeStyles(theme => (
const classes = {
  root: {
    paddingTop:100, 
    paddingBottom:50, 
    paddingLeft:'10%', 
    paddingRight:'10%',
    alignItems:'left',
    textAlign:'left',
    backgroundColor:'white'
  },
  freq: {
    fontFamily: 'Montserrat',
    fontSize: 11,
    textAlign:'justify',
    lineHeight: 1.2
  },
  verif:{
    fontFamily: 'Montserrat',
    fontSize: 11,
    textAlign:'justify',
    lineHeight: 1.2
  },
  centered:{
    fontFamily: 'Montserrat',
    fontSize: 36,
    textAlign:'center',
    lineHeight: 1.5
  },
  buttns:{ 
    textAlign:'center',
    alignItems:'center'
  },
  title:{
    fontFamily: 'Montserrat',
    fontSize: 14,
    textAlign:'justify'
  },
  subtitle:{
    fontFamily: 'Poppins',
    fontSize: 11,
    textAlign:'justify',
    lineHeight: 1.2
  },
  text:{
    fontFamily: 'Montserrat',
    fontSize: 11,
    textAlign:'justify',
    lineHeight: 1.2
  },
  tableText:{
    fontFamily: 'Montserrat',
    fontSize: '24px',
  }
}


//))
const Compiler = () => {
  const {colors} = theme
  const matchesMinWidth = useMediaQuery('(min-width:1050px)')
  const [openDialog, setOpenNTagDialog] = useState(false)
  const ThePlan = usePlan()
  if(!ThePlan._id){
    const localPlan = JSON.parse(localStorage.getItem("plan"))
    if(localPlan && localPlan.plan){
      ThePlan._id = localPlan.plan._id
      ThePlan._rev = localPlan.plan._rev
    }
}
  console.log(ThePlan)
  const nam = useName()
  const [sops, setSops] = useState({})
  const finSops = useFinalSOPs()
  const sopsOrder = useSelectedSOPs()
  const token = useToken()

  const handleToDrive = async () => {
    setOpenDialog({open:true, title: 'Please wait', txt:'The plan is being uploaded to Google Drive.',neg:null,pos:null,noLabel:null,yesLabel:null})
    const details = await getCompanyDetails(token)
    const doc = await handleCreateWord(sops, details)
    const data = new FormData()
    
    
    Packer.toBlob(doc).then(async blob => {
      data.append('document', blob)
      data.append('docName', `${ThePlan.name}.docx`)
      const docId = await uploadPlanToGDocs(token, data)
      window.open(`https://docs.google.com/document/d/${docId}/edit`, '_blank');
      setOpenDialog({open:false,txt:'',neg:null,pos:null,noLabel:null,yesLabel:null})
      // console.log(blob);
      // saveAs(blob, "example.docx");
      // console.log("Document created successfully");
    });
  }


  const toWord = () => {
    setOpenDialog({
      open:true,
      txt:'Do you want to save changes in the plan before downloading it?',
      neg: () => {
        prepareDownload()
      },
      pos: () => {
        handleUpdate()
        prepareDownload()
      },
      yesLabel: "Yes, update",
      noLabel: "No, just download it",
    });
  }
  
  const prepareDownload = async () => {
    setOpenDialog({open:true, title: 'Please wait', txt:'Wait while the file is ready',neg:null,pos:null,noLabel:null,yesLabel:null})
    if( sops?.hs?.sops?.length > 0 ){
      const dataUrl = await toPng(document.getElementById(sops.hs.id), { cacheBust: true, })
      const dataUrlDesc = await toPng(document.getElementById(`${sops.hs.id}_desc`), { cacheBust: true, })
      document.getElementById(`${sops.hs.id}_desc`).innerHTML = ''
      const e = document.getElementById(sops.hs.id)
      e.innerHTML = ''
      const img = new Image()
      const imgDesc = new Image()
      img.src = dataUrl
      imgDesc.src = dataUrlDesc
      e.appendChild(imgDesc)
      e.appendChild(img)
    }
    if( sops?.hi?.sops?.length > 0 ){
      const dataUrl = await toPng(document.getElementById(sops.hi.id), { cacheBust: true, })
      const e = document.getElementById(sops.hi.id)
      e.innerHTML = ''
      const img = new Image()
      img.src = dataUrl
      e.appendChild(img)
    }
    if( sops?.ccp?.sops?.length > 0 ){
      await Promise.all(sops.ccp.sops.map( async sop => {
        const dataUrl = await toPng(document.getElementById(sop._id), { cacheBust: true, })
        const e = document.getElementById(sop._id)
        e.innerHTML = `<h2 style=${classes.title}>${sop.title}</h2>`
        const img = new Image()
        img.src = dataUrl
        e.appendChild(img)
      }))
    }
    const content = `<html>
      <body>
        ${document.getElementById("source-html").innerHTML}
      </body>
    </html>`
    const data = await convertPlanToDocx(token, {content, planName: ThePlan.name + '.docx'})
    const url = window.URL.createObjectURL(new Blob([data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', ThePlan.name + '.zip') 
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    setOpenDialog({open:false,txt:'',neg:null,pos:null,noLabel:null,yesLabel:null})
    setRedirectToPreview(true)
    setSelectedModule('Organize')
  }



  const handleDialogNeg = () => {
    setOpenDialog({
      open:false, 
      txt:'',
      neg:null,
      pos:null
    })
  }
  const handleDialogPos = () => {
    const plan = {
      ...ThePlan,
      type:'archivedSOP'
    }
    savePlan(token, plan, 'deleted')
    setUpdatePlan(true)
    setPlan({name:'', _id:'', _rev:'', process:''})
    setSelectedSOPs([])
    setOpenPlan(false)
    setDocs(false)
    setStepsCompleted([false, false, false])
    setOpenDialog({
      open:false, 
      txt:'',
      neg:null,
      pos:null
    })
  }
  const updateHumanTag = (tag, x) => {
      let newPlanData = {
          ...ThePlan,
          humantags:{
              ...ThePlan?.humantags,
              [tag]:x
          }
      }
      if(tag == "AR")
          newPlanData.name = newPlanData.company_name + '_' + x + '_' + moment(newPlanData.date).format("MMDDYY")
      setPlan(newPlanData)
  }
  const upProc = (tag, x) => {
    let res = {...ThePlan}
    res['process']=x
    setPlan(res)
  }

  const setPlanTagsToSOPS = async (sopas) => {
    Promise.all(sopas.map( async sop => {
      const dat = await getSOPByID(sop._id, token)
      if( !dat?.humantags?.AR.some( elem => elem == ThePlan?.humantags?.AR ) )
        dat.humantags.AR.push(ThePlan?.humantags?.AR)
      if( !dat?.humantags?.LOC.some( elem => elem == ThePlan?.humantags?.LOC ) )
        dat.humantags.LOC.push(ThePlan?.humantags?.LOC)
      if( !dat?.humantags?.PR.some( elem => elem == ThePlan?.process ) )
        dat.humantags.PR.push(ThePlan?.process)
      dat.updated = new Date()
      await axios.post(
        `${api}/sopsqav2`, dat, 
        {
          headers: { Authorization: `Bearer ${token}` }
        },
      )
    }))
  }
  
  const handleUpdate = () => {
    if (ThePlan.process.length > 0){
      const sopas = finSops.map(
        x => ({_id:x._id, _rev:x._rev, title:x.title})
      )
      const plan = {
        ...ThePlan,
        sops:sopas, 
        type:'plan', 
        writer: nam,
        status: 'proposal'
      }
      console.log('ThePlan to save',ThePlan)
      setOpenDialog(
          {
              open:true, 
              txt:'Are you sure you want to update this plan?',
              pos : async () => {
                setPlanTagsToSOPS(sopas)
                savePlan(token, plan, 'updated')
                setUpdatePlan(true)
                setPlan(plan)
                setSelectedSOPs(sopas)
                localStorage.setItem('plan', JSON.stringify({
                  openPlan: true,
                  plan,
                }))
                setOpenDialog({open:false, txt:'',neg:null,pos:null})
              },
              neg : () => setOpenDialog({open:false, txt:'',neg:null,pos:null})
          }
      ) 
    } else {
      alert("Process must be filled.")
    }
  }

  const handleDelete = () => {
    setOpenDialog(
      {
        open:true, 
        txt:'You are about to delete this plan, are you sure?',
        neg : handleDialogNeg,
        pos : handleDialogPos
      }
    )
  }

  const handleSaveNew = () => {
    setOpenDialog({
      open:true,
      txt:'Do you want to create a new plan or update the current one ?',
      neg: () => setOpenDialog({open:false,txt:'',neg:null,pos:null,noLabel:null,yesLabel:null}),
      pos: () => {
        const sopas = finSops.map(
          x => ({_id:x._id, _rev:x._rev, title:x.title})
        )
        const plan = {
          ...ThePlan,
          sops:sopas, 
          type:'plan', 
          writer: nam,
          status: 'proposal'
        }
        if (ThePlan.process.length > 0){
          delete plan['_id']
          delete plan['_rev']
          
          savePlan(token, plan, 'saved')
          setUpdatePlan(true)
          setPlan(plan)
          setSelectedSOPs(sopas)
          setPlanTagsToSOPS(sopas)
          localStorage.setItem('plan', JSON.stringify({
            openPlan: true,
            plan,
          }))
        } else {
          alert("Process must be filled.")
        }
        setOpenDialog({open:false,txt:'',neg:null,pos:null,noLabel:null,yesLabel:null})
      },
      yesLabel: "Yes, I just started a brand new plan",
      noLabel: "No, I am updating an existing plan. Cancel",
    });
  }

  const handleApprove = () => {
    if (ThePlan.process.length > 0){
      setOpenDialog(
        {
          open:true, 
          txt:'Are you sure you want to approve this plan?',
          pos : () => {
            const sopas = sops.map(
              x => ({_id:x._id, _rev:x._rev, title:x.title})
            )
            const plan = {
              ...ThePlan,
              sops:sopas, 
              type:'plan', 
              writer: nam,
              status: 'approved'
            }
            savePlan(token, plan, 'approved')
            setUpdatePlan(true)
            setPlan(plan)
            setSelectedSOPs(sopas)
            setSelectedModule('Organize')
            setOpenDialog({
              open:false, 
              txt:'',
              neg:null,
              pos:null
            })
          },
          neg : () => {
            setOpenDialog({
              open:false, 
              txt:'',
              neg:null,
              pos:null
            })
          }
        }
      )
    } 
    else
    {
      alert("Process must be filled.")
    }
  }

  const sortSops = () => {
    const sorted = _.sortBy(finSops, x => _.findIndex( sopsOrder, y => x._id === y._id ))
    const inputSops = sorted.filter( sop => sop.doctype === editorType.hi)
    const stepSops = sorted.filter( sop => sop.doctype === editorType.hs) 
    setSops({
      ccp: {sops: sorted.filter( sop => sop.doctype === editorType.ccp) },
      sop: {sops: sorted.filter( sop => sop.doctype === editorType.sop || sop.doctype === editorType.doc ) },
      hi: {sops: inputSops, id:'00001', doctype : editorType.hi }, 
      hs: {sops: stepSops, id:'00002', doctype: editorType.hs }
    })
    setFinalSOPs(sorted)
  }

  useEffect( () => {
    sortSops()
  }, [])

  return (
    <Paper elevation={3} 
      style={classes.root} >
      <NewTagDialog isOpen={openDialog} onClose={() => setOpenNTagDialog(false)} docTags={true} />
      <Dialog/>
      <ButtonGroup 
        variant={ matchesMinWidth ? "contained" : "text"}
        color="primary"
        aria-label="contained primary button group"
        style={classes.buttns}
        orientation={ matchesMinWidth ? 'horizontal' : 'vertical'}
      >

        <Button
          variant="contained"
          
          startIcon={<CloudUploadIcon />}
          onClick={handleToDrive}
          style={{ 
            backgroundColor: colors.secondary,
            color:colors.light,
            bottom: 0,
            minWidth:'178px',
          }}
        >
          Export to Docs
        </Button>
        <Button
          variant="contained"
          
          startIcon={<CloudDownload />}
          onClick={toWord}
          style={{ 
            backgroundColor: colors.secondary,
            color:colors.light,
            bottom: 0
          }}
        >
          Download
        </Button>
        <Button
          variant="contained"
          
          startIcon={<SaveIcon />}
          onClick={handleUpdate}
          style={{ 
            backgroundColor: colors.secondary,
            color:colors.light,
            bottom: 0
          }}
        >
          Update
        </Button>

        <Button
          variant="contained"
          
          startIcon={<SaveIcon />}
          onClick={handleSaveNew}
          style={{ 
            backgroundColor: colors.secondary,
            color:colors.light,
            bottom: 0,
            minWidth:'152px',
          }}
        >
          Save as new
        </Button>
        <Button
          variant="contained"
          startIcon={<LabelIcon />}
          onClick={ () => setOpenNTagDialog(true)}
          style={{ 
            backgroundColor: colors.secondary,
            color:colors.light,
            bottom: 0,
            minWidth:'120px',
          }}
        >
          New Tag
        </Button>
        <Button
          variant="contained"
          
          startIcon={<ThumbUpIcon />}
          onClick={handleApprove}
          style={{ 
            backgroundColor: colors.secondary,
            color:colors.light,
            bottom: 0,
            minWidth:'242px',
          }}
        >
          Mark Plan as APPROVED
        </Button>


        <Button
            variant="contained"
            
            startIcon={<DeleteIcon />}
            onClick={handleDelete}
            style={{ 
              backgroundColor: colors.secondary,
              color:colors.light,
              bottom: 0
            }}
          >
            Delete
        </Button>
      </ButtonGroup>
      <div style={{ display:'flex', flexDirection:'column' }}>
        <h3>NAME OF THE PLAN</h3>
        <TextField 
          id="name" 
          label="Name" 
          value={ThePlan.name} 
          onChange={(e) => setPlan({...ThePlan, name: e.target.value})}
          style={{
            fontSize: 'xxx-large',
            paddingBottom:30
          }}
          disabled
        />
        <h3>COMPANY NAME</h3>
        <TextField 
          id="company_name" 
          label="Company Name" 
          value={ThePlan.company_name} 
          onChange={(e) => {
            const name = e.target.value + '_' + ThePlan.humantags?.AR + '_' + moment(ThePlan.date).format("MMDDYY")
            setPlan({...ThePlan, company_name: e.target.value, name})
          }}
          style={{
            fontSize: 'xxx-large',
            paddingBottom:30
          }}
        />
        <h3>AUDIT REQUIREMENT</h3>
        <Auto 
          id="AR" 
          value={ThePlan.humantags?.AR}
          type={"Audit Requirements"} 
          updateProcess={updateHumanTag} 
          freeSolo={false}
          tag={'AR'}
        /> 
        <h3>LOCATION</h3>
        <Auto 
          id="LOC" 
          value={ThePlan.humantags?.LOC}
          type={"Location"} 
          updateProcess={updateHumanTag} 
          tag={'LOC'}
        />
        <h3>DATE</h3>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yy"
                margin="normal"
                id="date-picker-inline"
                label="Date"
                value={ThePlan.date}
                onChange={(date)=>{
                    setPlan({...ThePlan, date})
                }}
                KeyboardButtonProps={{
                    'aria-label': 'change date',
                }}
                style={{width:'100%'}}
            />
        </MuiPickersUtilsProvider>
        <h3>PROCESS OF THE PLAN</h3>
        <Auto 
          id="process" 
          label="Process" 
          value={ThePlan.process} 
          tag="PR"
          updateProcess={upProc} 
          type={'Process'}
        />
      </div>
      <div id={'source-html'}>
        { sops?.sop?.sops?.length > 0 &&
          <>
            <h1>Standard Operating Procedures & Documents</h1>
            {sops?.sop?.sops.map((x) => (<SopView x={x} /> ))}
          </>
        }
        { 
          sops?.hi?.sops?.length > 0 &&
          <>
            <h1>Hazard Analysis inputs</h1>
            <GroupedSopViewe sops={sops.hi.sops} id={sops.hi.id} doctype={sops.hi.doctype} />
          </>
        }
        { 
          sops?.hs?.sops?.length > 0 &&
          <>
            <h1>Hazard Analysis process step</h1>
            <GroupedSopViewe sops={sops.hs.sops} id={sops.hs.id} doctype={sops.hs.doctype} />
          </>
        }
        { sops?.ccp?.sops?.length > 0 &&
          <>
            <h1>Critical Contro Points</h1>
            {sops?.ccp?.sops.map((x) => (<SopView x={x} /> ))}
          </>
        }
      </div>
      <ButtonGroup 
        variant={ matchesMinWidth ? "contained" : "text"}
        color="primary"
        aria-label="contained primary button group"
        style={classes.buttns}
        orientation={ matchesMinWidth ? 'horizontal' : 'vertical'}
      >

        <Button
          variant="contained"
          
          startIcon={<CloudUploadIcon />}
          onClick={handleToDrive}
          style={{ 
            backgroundColor: colors.secondary,
            color:colors.light,
            bottom: 0,
            minWidth:'178px',
          }}
        >
          Export to Docs
        </Button>
        <Button
          variant="contained"
          
          startIcon={<CloudDownload />}
          onClick={toWord}
          style={{ 
            backgroundColor: colors.secondary,
            color:colors.light,
            bottom: 0
          }}
        >
          Download
        </Button>
        <Button
          variant="contained"
          
          startIcon={<SaveIcon />}
          onClick={handleUpdate}
          style={{ 
            backgroundColor: colors.secondary,
            color:colors.light,
            bottom: 0
          }}
        >
          Update
        </Button>

        <Button
        variant="contained"
        
        startIcon={<SaveIcon />}
        onClick={handleSaveNew}
        style={{ 
          backgroundColor: colors.secondary,
          color:colors.light,
          bottom: 0,
          minWidth:'152px',
        }}
        >
        Save as new
        </Button>
        <Button
          variant="contained"
          startIcon={<LabelIcon />}
          onClick={ () => setOpenNTagDialog(true)}
          style={{ 
            backgroundColor: colors.secondary,
            color:colors.light,
            bottom: 0,
            minWidth:'120px',
          }}
        >
          New Tag
        </Button>
        <Button
          variant="contained"
          
          startIcon={<ThumbUpIcon />}
          onClick={handleApprove}
          style={{ 
            backgroundColor: colors.secondary,
            color:colors.light,
            bottom: 0,
            minWidth:'242px',
          }}
        >
          Mark Plan as APPROVED
        </Button>

          <Button
            variant="contained"
            
            startIcon={<DeleteIcon />}
            onClick={handleDelete}
            style={{ 
              backgroundColor: colors.secondary,
              color:colors.light,
              bottom: 0
            }}
          >
            Delete
          </Button>
      </ButtonGroup>
    </Paper>
  )
}
export default Compiler
